<template>
  <div>
    <the-headersider />

    <section>
      <base-card>
        <h4>
          Payments for:
          <span v-if="clientName">{{ clientName }}</span>
        </h4>

        <br />

        <table
          v-if="filteredPayments.length"
          class="table table-striped table-bordered centre"
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Client Name</th>
              <th>Reference</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="payment in filteredPayments"
              :key="payment.id"
            >
              <td>{{ formatDate(payment.payment_date) }}</td>
              <td>{{ formatAmount(payment.amount) }}</td>
              <td>{{ getClientName(payment.account_number) }}</td>
              <td>{{ payment.payment_reference }}</td>
            </tr>
          </tbody>
        </table>

        <div v-else-if="loaded" class="no-data">
          No payments found for this client.
        </div>

        <br />

        <button
          v-if="filteredPayments.length"
          @click="downloadPDF"
          class="btn btn-primary"
        >
          Download Client Payments
        </button>
      </base-card>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      payments: [],
      clients: [],
      loaded: false,
    };
  },

  computed: {
    clientId() {
      // Get client ID from route parameter
      return Number(this.$route.params.client);
    },

    // Filter payments by clientId (account_number)
    filteredPayments() {
      return this.payments.filter(
        payment => Number(payment.account_number) === this.clientId
      );
    },

    // Get client name for header
    clientName() {
      const client = this.clients.find(c => c.id === this.clientId);
      return client ? client.client_name : "";
    },
  },

  async created() {
    try {
      const [paymentsRes, clientsRes] = await Promise.all([
        axios.get("https://api.roberms.com/get/mpesapayments"),
        axios.get("https://api.roberms.com/get/clients"),
      ]);

      this.payments = paymentsRes.data;
      this.clients = clientsRes.data;
      this.loaded = true;
    } catch (err) {
      console.error("Error loading data:", err);
      this.loaded = true;
    }
  },

  methods: {
    // Format amount nicely
    formatAmount(amount) {
      return Number(amount).toLocaleString();
    },

    // Format date as yyyy-mm-dd
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    // Get client name by account number
    getClientName(accountNumber) {
      const client = this.clients.find(c => c.id === Number(accountNumber));
      return client ? client.client_name : "Unknown";
    },

    // Download filtered payments as PDF
    downloadPDF() {
      const pdf = new jsPDF();

      const columns = ["Date", "Amount", "Client Name", "Reference"];
      const rows = this.filteredPayments.map(payment => [
        this.formatDate(payment.payment_date),
        this.formatAmount(payment.amount),
        this.getClientName(payment.account_number),
        payment.payment_reference,
      ]);

      pdf.text("Payment Report for " + this.clientName, 14, 20);

      pdf.autoTable({
        head: [columns],
        body: rows,
        startY: 30,
      });

      pdf.save(this.clientName + "_payments.pdf");
    },
  },
};
</script>

<style scoped>
body {
  background: #fdfbfb;
  margin-left: 220px;
}

.no-data {
  text-align: center;
  padding: 20px;
  font-weight: bold;
  color: #888;
}
</style>